import React, {Component} from 'react'
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import Error from "../single_components/Error";


class Physiological_biometrics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    calculateBMI(name,value){
        let entry= this.state.entry
        let maxNum=name ==="Height_m"?300:999

        if(value&&value<=maxNum ){
            this.props.onValueChange(name, value)

            if(entry.Height_m && entry.Weight_kg){
                let height= parseFloat(entry.Height_m)
                let weight= parseFloat(entry.Weight_kg)
                let bmi= ((weight/height)/height)*10000
                bmi=bmi.toFixed(2)
                this.props.onValueChange("BMI", bmi.toString())
            }else{
                this.props.onValueChange("BMI", "0")
            }
        }
    }
    componentDidMount() {
    }

    render() {
        let {t} = this.props

        let maxLastTest=new Date()

        let minLastTest=new Date()
        minLastTest.setFullYear(maxLastTest.getFullYear()-10)
        
        let entry= this.state.entry
        let Last_test_date= entry.Last_test_date?new Date(entry.Last_test_date):""

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}> {t('patient_boarding.Weight')}</label>
                        <input  className={'inputBoxStyle'} type="number" name="Weight" value={entry.Weight_kg ? entry.Weight_kg: ""}
                                maxLength={3} min={30} max={999}
                                onChange={(event) => this.calculateBMI("Weight_kg", event.target.value)}/>

                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Height')}</label>
                        <input  className={'inputBoxStyle'} type="number"  name="Height" value={entry.Height_m}
                                maxLength={3} min={0} max={300}
                                onChange={(event) => this.calculateBMI("Height_m", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Calculate_BMI')}</label>
                        <input readOnly className={'inputBoxStyle'} type="number" name="BMI" value={entry.BMI}
                               maxLength={2} min={10} max={50}
                        />
                    </div>
                        <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Heart_rate')}</label>
                        <input  className={'inputBoxStyle'} type="number"  name="Pulse" value={entry.Pulse_bpm}
                        maxLength={3} min={40} max={200}
                        onChange={(event) => this.props.onValueChange("Pulse_bpm", event.target.value)}/>
                        </div>


                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'}>{t('patient_boarding.SystolicBloodPressure')}</label>
                            <Error isShown={!!(this.props.errors)['Systolic_blood_press_mmHg']} errorMessage={(this.props.errors)['Systolic_blood_press_mmHg']}/>
                        </div>
                        <input  className={'inputBoxStyle'} type="text"  name="SystolicBloodPressure" defaultValue={entry.Systolic_blood_press_mmHg}
                                maxLength={3} min={30} max={250}
                                onChange={(event) => this.props.onValueChange("Systolic_blood_press_mmHg", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'}>{t('patient_boarding.DiastolicBloodPressure')}</label>
                            <Error isShown={!!(this.props.errors)['Diastolic_blood_press_mmHg']} errorMessage={(this.props.errors)['Diastolic_blood_press_mmHg']}/>
                        </div>
                        <input  className={'inputBoxStyle'} type="text"  name="DiastolicBloodPressure" defaultValue={entry.Diastolic_blood_press_mmHg}
                                maxLength={3} min={30} max={200}
                                onChange={(event) => this.props.onValueChange("Diastolic_blood_press_mmHg", event.target.value)}/>
                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Blood_type')}</label>
                        <select  className={'selectBox'} id="CommercialLicense" name="BloodType" value={entry.Blood_type}
                                 onChange={(event) => this.props.onValueChange("Blood_type", event.target.value)}>
                            <option/>
                            <option value="O-">O-</option>
                            <option value="O+">O+</option>
                            <option value="A-">A-</option>
                            <option value="A+">A+</option>
                            <option value="B-">B-</option>
                            <option value="B+">B+</option>
                            <option value="AB-">AB-</option>
                            <option value="AB+">AB+</option>
                        </select>
                    </div>


                    </div>
                <div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Sugar_level')}</label>
                        <input  className={'inputBoxStyle'} type="number"  name="SugarLevel" defaultValue={entry.Sugar_level}
                                maxLength={2} min={0} max={20}
                                onChange={(event) => this.props.onValueChange("Sugar_level", event.target.value)}/>
                    </div>

                <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Last_test')}</label>
                      {/*  <DatePicker
                            className={'inputBoxStyle'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={new Date(entry.Last_test_date)}
                            maxDate={maxLastTest}
                            minDate={minLastTest}
                            onChange={(event) => this.props.onValueChange("Last_test_date", event)}/>*/}


                    <DatePicker
                        className={'inputBoxStyle'}
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        dateFormat="dd/MM/yyyy"
                        selected={Last_test_date}
                        maxDate={maxLastTest}
                        minDate={minLastTest}
                        onChange={(event) => this.props.onValueChange("Last_test_date", event)}/>

                    </div>

                </div>
            </div>

        )
    }
}

Physiological_biometrics.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default Physiological_biometrics;
